// Admin-uploaded flyers: shared fetch cache so the Nav menu and /flyers page
// stay in sync, and admin edits can refresh both instantly.
import { useEffect, useState } from "react";
import api from "./api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
let cache = null;
const listeners = new Set();

export const assetUrl = (path) => `${BACKEND_URL}${path}`;

export function loadFlyers(force = false) {
  if (!cache || force) {
    cache = api.get("/flyers").then((r) => r.data.flyers || []).catch(() => []);
    cache.then((list) => listeners.forEach((fn) => fn(list)));
  }
  return cache;
}

export function useUploadedFlyers() {
  const [flyers, setFlyers] = useState([]);
  useEffect(() => {
    listeners.add(setFlyers);
    loadFlyers().then(setFlyers);
    return () => listeners.delete(setFlyers);
  }, []);
  return flyers;
}
